import { create } from 'zustand'

/** The lake row under inspection — surfaced in the Control Plane rail. */
export interface SelectedRow {
  domain: string
  dataset: string
  row: Record<string, unknown>
}

interface LedgerSelectionState {
  selected: SelectedRow | null
  select: (s: SelectedRow | null) => void
}

export const useLedgerSelection = create<LedgerSelectionState>((set) => ({
  selected: null,
  select: (selected) => set({ selected }),
}))
